/**
 * GarageWhiz — Theme JavaScript
 * Handles: sticky header, mobile menu, carousel
 */
(function() {
  'use strict';

  /* ============================================================
     Sticky Header
     ============================================================ */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    if (header._garagewhizHeaderCleanup) header._garagewhizHeaderCleanup();

    var scrollThreshold = 50;
    var behavior = header.getAttribute('data-header-behavior') || 'standard';
    var animationFrame = null;
    var lastScrollY = getScrollY();

    function getScrollY() {
      var scrollingElement = document.scrollingElement || document.documentElement;
      return Math.max(window.pageYOffset || 0, window.scrollY || 0, scrollingElement.scrollTop || 0, document.body.scrollTop || 0);
    }

    function updateHeader() {
      animationFrame = null;
      var currentScrollY = getScrollY();
      var isPastThreshold = currentScrollY > scrollThreshold;

      header.classList.toggle('header--scrolled', isPastThreshold);

      if (behavior !== 'transparent_auto_hide') {
        header.classList.remove('header--transparent', 'header--hidden');
        lastScrollY = currentScrollY;
        return;
      }

      header.classList.toggle('header--transparent', !isPastThreshold);
      header.classList.toggle('header--hidden', isPastThreshold && currentScrollY > lastScrollY);
      lastScrollY = currentScrollY;
    }

    function requestUpdate() {
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(updateHeader);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
    window.addEventListener('wheel', requestUpdate, { passive: true });
    window.addEventListener('touchmove', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    header._garagewhizHeaderCleanup = function() {
      window.removeEventListener('scroll', requestUpdate);
      document.removeEventListener('scroll', requestUpdate, true);
      window.removeEventListener('wheel', requestUpdate);
      window.removeEventListener('touchmove', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
    };

    updateHeader();
  }

  /* ============================================================
     Mobile Menu
     ============================================================ */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var menuIcon = toggle.querySelector('.header__menu-icon');
    var closeIcon = toggle.querySelector('.header__close-icon');
    var isOpen = false;

    function openMenu() {
      isOpen = true;
      menu.classList.add('is-open');
      if (menuIcon) menuIcon.style.display = 'none';
      if (closeIcon) closeIcon.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      isOpen = false;
      menu.classList.remove('is-open');
      if (menuIcon) menuIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function() {
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close on link click
    var links = menu.querySelectorAll('a');
    links.forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ============================================================
     Carousel (Portfolio)
     ============================================================ */
  var carouselIndex = {};   /* section id -> last slide index, survives editor re-renders */

  function sectionIdOf(node) {
    var section = node && node.closest ? node.closest('.shopify-section') : null;
    return section ? section.id : null;
  }

  function initCarousels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var carousels = scope.querySelectorAll('[data-carousel]');

    carousels.forEach(function(carousel) {
      /* The theme editor re-renders a whole section on every setting change, so
         this runs again against fresh DOM. Guard against double-binding when the
         same nodes are handed to us twice. */
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');

      if (!track) return;

      var slides = track.children;
      var currentIndex = 0;
      var slideCount = slides.length;
      var sectionId = sectionIdOf(carousel);

      function goToSlide(index, instant) {
        if (!slideCount) return;
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;
        currentIndex = index;
        if (sectionId) carouselIndex[sectionId] = currentIndex;

        var firstSlide = slides[0];
        var slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : carousel.getBoundingClientRect().width;

        if (instant) {
          var previous = track.style.transition;
          track.style.transition = 'none';
          track.style.transform = 'translate3d(' + (-(currentIndex * slideWidth)) + 'px, 0, 0)';
          void track.offsetWidth;
          track.style.transition = previous || '';
        } else {
          track.style.transform = 'translate3d(' + (-(currentIndex * slideWidth)) + 'px, 0, 0)';
        }

        dots.forEach(function(dot, i) {
          dot.classList.toggle('portfolio__dot--active', i === currentIndex);
        });
      }

      /* Let the editor hooks below drive this carousel. */
      carousel.gwGoToSlide = goToSlide;
      carousel.gwSlideIndexOf = function(node) {
        var slide = node && node.closest ? node.closest('.portfolio__slide') : null;
        if (!slide || slide.parentElement !== track) return -1;
        return Array.prototype.indexOf.call(track.children, slide);
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide(currentIndex + 1);
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.getAttribute('data-carousel-dot'), 10);
          goToSlide(index);
        });
      });

      window.addEventListener('resize', function() { goToSlide(currentIndex, true); }, { passive: true });

      // Touch/swipe support
      var startX = 0;
      var endX = 0;

      track.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function(e) {
        endX = e.changedTouches[0].clientX;
        var diff = startX - endX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
      }, { passive: true });

      /* Fresh render after an editor edit: put the slider back where it was
         instead of snapping to slide 1. */
      if (sectionId && carouselIndex[sectionId]) goToSlide(carouselIndex[sectionId], true);
    });
  }

  /* ============================================================
     Smooth Scroll for anchor links
     ============================================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var targetId = link.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('[data-header]');
          var offset = headerHeight ? headerHeight.offsetHeight : 0;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  /* ============================================================
     Formspree Quote Form with image attachments
     ============================================================ */
  function initQuoteForm() {
    var form = document.querySelector('[data-quote-form]');
    var success = document.querySelector('[data-quote-success]');
    if (!form || !success) return;

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function(response) {
          if (!response.ok) throw new Error('Quote request failed');
          form.hidden = true;
          success.hidden = false;
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        })
        .catch(function() {
          if (button) button.disabled = false;
          window.alert('We could not send your request. Please call 786-521-3235 or email info@garage-whiz.com.');
        });
    });
  }

  /* ============================================================
     Scroll Reveal — Text & Images
     Adds classes only when supported, preserving normal rendering if
     JavaScript is unavailable. It is also safe to re-run after Theme Editor
     section re-renders.
     ============================================================ */
  var scrollRevealObserver = null;

  function revealTargetSelector() {
    return [
      '.hero__headline',
      '.hero__subtitle',
      '.hero__actions',
      '.services__header .section-eyebrow',
      '.services__header .section-heading',
      '.services__header .section-subheading',
      '.portfolio__header .section-eyebrow',
      '.portfolio__header .section-heading',
      '.portfolio__header .section-subheading',
      '.service-card__image-wrap',
      '.service-card__content',
      '.portfolio__image-wrap',
      '.portfolio__caption',
      '.stats__item',
      '.trust-badge',
      '.seo-copy__eyebrow',
      '.seo-copy__heading',
      '.seo-copy__body',
      '.rich-text-band__eyebrow',
      '.rich-text-band__heading',
      '.rich-text-band__body',
      '.service-gallery__eyebrow',
      '.service-gallery__heading',
      '.service-gallery__intro',
      '.service-gallery__tabs',
      '.service-gallery__description',
      '.service-gallery__image-button',
      '.testimonials__eyebrow',
      '.testimonials__heading',
      '.testimonials__intro',
      '.testimonial__transformation-photo',
      '.testimonial__copy',
      '.testimonial__person',
      '.contact__info .section-eyebrow',
      '.contact__info .section-heading',
      '.contact__description',
      '.contact__detail-item',
      '.contact__social',
      '.contact__form-wrap',
      '.footer__brand',
      '.footer__social',
      '.footer__bottom'
    ].join(',');
  }

  function imageRevealSelector() {
    return [
      '.service-card__image-wrap',
      '.portfolio__image-wrap',
      '.service-gallery__image-button',
      '.testimonial__transformation-photo'
    ].join(',');
  }

  function showReveal(element) {
    element.classList.add('is-visible');
    if (scrollRevealObserver) scrollRevealObserver.unobserve(element);
  }

  function initScrollReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var targets = scope.querySelectorAll(revealTargetSelector());
    if (!targets.length) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var observerSupported = 'IntersectionObserver' in window;
    var photoSelector = imageRevealSelector();

    if (!reducedMotion && observerSupported && !scrollRevealObserver) {
      scrollRevealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) showReveal(entry.target);
        });
      }, {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px'
      });
    }

    targets.forEach(function(target, index) {
      if (target.dataset.gwRevealReady === 'true') return;

      target.dataset.gwRevealReady = 'true';
      target.classList.add('gw-reveal');
      target.classList.add(target.matches(photoSelector) ? 'gw-reveal--image' : 'gw-reveal--text');
      target.style.setProperty('--gw-reveal-delay', ((index % 5) * 70) + 'ms');

      if (reducedMotion || !observerSupported) {
        showReveal(target);
      } else {
        scrollRevealObserver.observe(target);
      }
    });
  }

  function destroyScrollReveal(root) {
    if (!scrollRevealObserver || !root || !root.querySelectorAll) return;
    root.querySelectorAll('.gw-reveal').forEach(function(target) {
      scrollRevealObserver.unobserve(target);
    });
  }

  /* ============================================================
     Initialize All
     ============================================================ */
  function init() {
    initStickyHeader();
    initMobileMenu();
    initCarousels();
    initSmoothScroll();
    initQuoteForm();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ============================================================
     Theme editor hooks
     A section is re-rendered from scratch on every setting change, which
     replaces the DOM and drops every listener bound above. Without these the
     carousel is inert and parked on slide 1 until the page is saved.
     ============================================================ */
  function carouselFor(node) {
    return node && node.closest ? node.closest('[data-carousel]') : null;
  }

  document.addEventListener('shopify:section:load', function(event) {
    initCarousels(event.target);
    initScrollReveal(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.target && event.target.id;
    if (id) delete carouselIndex[id];
    destroyScrollReveal(event.target);
  });

  /* Selecting or editing a Project Slide scrolls the carousel to that slide. */
  function followBlock(event) {
    var carousel = carouselFor(event.target);
    if (!carousel || typeof carousel.gwGoToSlide !== 'function') return;
    var index = carousel.gwSlideIndexOf(event.target);
    if (index >= 0) carousel.gwGoToSlide(index);
  }

  document.addEventListener('shopify:block:select', followBlock);
  document.addEventListener('shopify:block:deselect', function() {});
})();